// initialize all components on page
Component.initComponents();

// scroll form into view after submit
new ScrollToFormNotification('[data-form-anchor]');
